// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cb6bc6bc","977":"d2406619"}[chunkId] + ".chunk.js";
};